import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { motion } from "framer-motion";
import Cookies from "js-cookie";
import Lottie from "lottie-react";
import checkAnimationData from "../animations/checkAnimationData";

const CLEAR_COOKIE_KEYS = [
  "additionalEvidenceToken",
  "additionalEvidenceApplication",
  "verifiedPhoneNumber",
];

const AdditionalEvidenceCompletePage = () => {
  const navigate = useNavigate();
  const [accessCode, setAccessCode] = useState("");

  useEffect(() => {
    // 쿠키 삭제 전에 accessCode를 보존
    try {
      const applicationCookie = Cookies.get("additionalEvidenceApplication");
      if (applicationCookie) {
        const parsed = JSON.parse(applicationCookie);
        if (parsed?.accessCode) setAccessCode(parsed.accessCode);
      }
    } catch (e) {}

    CLEAR_COOKIE_KEYS.forEach((key) => {
      Cookies.remove(key, { path: "/" });
      Cookies.remove(key);
    });
  }, []);

  const handleCheckStatus = () => {
    if (accessCode) {
      navigate(
        `/check-status?displayAccessCode=${encodeURIComponent(accessCode)}`,
      );
    } else {
      navigate("/check-status");
    }
  };

  const pageVariants = {
    initial: { opacity: 0 },
    in: { opacity: 1, transition: { duration: 0.5 } },
    out: { opacity: 0, transition: { duration: 0.3 } },
  };

  const contentVariants = {
    initial: { opacity: 0, y: 20 },
    in: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, delay: 0.2, staggerChildren: 0.1 },
    },
  };

  return (
    <PageBackground>
      <Container
        variants={pageVariants}
        initial="initial"
        animate="in"
        exit="out"
      >
        <Content variants={contentVariants} initial="initial" animate="in">
          <IconContainer>
            <Lottie
              animationData={checkAnimationData}
              loop={false}
              autoplay={true}
              style={{ width: 250, height: 250 }}
            />
          </IconContainer>

          <TitleContainer>
            <TitleLine>증거 자료 제출이</TitleLine>
            <TitleLine>완료되었습니다</TitleLine>
          </TitleContainer>

          <CompleteButtonContainer>
            <CheckStatusButton onClick={handleCheckStatus}>
              신청내역 조회하기
            </CheckStatusButton>
            <CompleteButton onClick={() => navigate("/")}>
              홈으로 가기
            </CompleteButton>
          </CompleteButtonContainer>
        </Content>
      </Container>
    </PageBackground>
  );
};

const PageBackground = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #f7f7f7;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;

  @media (min-width: 769px) {
    padding: 20px;
  }
`;

const Container = styled(motion.div)`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f7f7f7;

  @media (max-width: 768px) {
    min-height: 100vh;
    padding: 0;
    max-width: 100%;
    margin: 0;
  }

  @media (min-width: 769px) {
    border-radius: 20px;
    max-width: 470px;
    margin: 0 auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    padding: 20px;
  }
`;

const Content = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 40px 20px;
  min-height: 100vh;

  @media (min-width: 769px) {
    min-height: auto;
  }
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 250px;
  height: 250px;
  border-radius: 50%;
  margin-bottom: 40px;
  margin-top: auto;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: auto;
  text-align: center;
`;

const TitleLine = styled.h1`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.4;
  color: #333;
  margin: 0;
  text-align: center;
`;

const CompleteButtonContainer = styled.div`
  width: 100%;
  margin-top: auto;
  padding-bottom: 80px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (min-width: 769px) {
    max-width: 470px;
    margin-top: 40px;
  }
`;

const CompleteButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e31c20;
  color: white;
  width: 100%;
  height: 56px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: background-color 0.2s;

  &:hover {
    background-color: #b01418;
  }
`;

const CheckStatusButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  color: #333;
  width: 100%;
  height: 56px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  transition:
    background-color 0.2s,
    border-color 0.2s;

  &:hover {
    background-color: #fafafa;
    border-color: #b3b3b3;
  }
`;

export default AdditionalEvidenceCompletePage;
